import appConstants from '../constants';
import fetchService from './fetchService';
import convertPartnerQualIconsStringToArray from '../utils/convertQualIconsStringToArray';
import convertQualIconsArrayToRolesAndLevelsObject from '../utils/convertQualIconsArrayToRolesAndLevelsObject';
import extractDiversityInfoFromQualifications from '../utils/extractDiversityInfoFromQualifications';
const SERVICE_URL = `${appConstants.SERVICE_BASE_URL}${appConstants.SERVICE_REQUEST_FETCH_PARTNERS_URL}`;

// {
// "LOCATION_IDS": "136561069",
// "SPECIALIZATION_IDS": "136630676,2342",
// "LEVEL_IDS": "136667319,136644020,136644021",
// "SITE_ID" : "2132140",
// "SORT_ORDER": "DESC",
// "SORT_BY":"badge_rank",
// "pageSize": 50,
// "pageCount": 1
// }
// Later i will add PARTNER_KEYWORD_ID

function convertPartnerSiteIds(partnerSiteIds) {
  return Object.fromEntries(
    new Map([
      [appConstants.KEY_SITE_IDS, partnerSiteIds]
    ])
  )
}

function convertPaginationCriteria(paginationCriteria) {
  return Object.fromEntries(
    new Map([
      [appConstants.KEY_PAGE_SIZE, paginationCriteria[appConstants.KEY_PAGE_SIZE]],
      [appConstants.KEY_PAGE_COUNT, paginationCriteria[appConstants.KEY_PAGE_COUNT]]
    ])
  );
}

function convertSortCriteria(sortCriteria) {
  return Object.fromEntries(
    new Map([
      [appConstants.KEY_SORT_BY, sortCriteria[appConstants.KEY_SORT_BY]],
      [appConstants.KEY_SORT_ORDER, sortCriteria[appConstants.KEY_SORT_ORDER]]
    ])
  );
}

function prepareInputParameters(partnerSiteIds, paginationCriteria, sortCriteria) {
  return {
    ...convertPartnerSiteIds(partnerSiteIds),
    ...convertPaginationCriteria(paginationCriteria),
    ...convertSortCriteria(sortCriteria)
  };
}

function processData(data, arePartnerSaved) {
  let processedData = {
    fetchedPartners: [],
    fetchedPartnerCount: 0
  }
  if(!!data.data && !!data.data.length) {
    processedData = {
      fetchedPartners: data.data.map(partner => {
        const rolesAndLevels =
          convertQualIconsArrayToRolesAndLevelsObject(
            convertPartnerQualIconsStringToArray(partner[appConstants.KEY_QUAL_ICONS])
          );
        const diversityInfo = extractDiversityInfoFromQualifications(partner?.qualifications||[]);
        return {
          ...partner,
          ...rolesAndLevels,
          ...diversityInfo,
          isSaved: arePartnerSaved,
          savedCount: 1,
        }
      }),
      fetchedPartnerCount: data.matches
    }
  }
  return processedData;
}

export default async function fetchPartners(
  partnerSiteIds,
  paginationCriteria = { pageSize: 50, pageCount: 1 },
  sortCriteria = {},
  arePartnerSaved = true
) {
  const inputParameters = prepareInputParameters(partnerSiteIds, paginationCriteria, sortCriteria);

  let fetchedDataObject = await fetchService(
    'fetchPartners',
    SERVICE_URL,
    {
      ...appConstants.SERVICE_REQUEST_FETCH_PARTNERS_CONFIG,
      body: JSON.stringify(inputParameters)
    }
  );

  return !fetchedDataObject.success?
    {
      hasError: true,
      errorMessage: fetchedDataObject.statusMessage,
      fetchedPartners: [],
      fetchedPartnerCount: 0
    }:
    {
      hasError: false,
      errorMessage: null,
      ...processData(fetchedDataObject, arePartnerSaved)
    };
}


